if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();

      // setTimeout(this.clearLazyClass.bind(this), 4000);
    }
    clearLazyClass(){
      this.querySelectorAll("[loading]").forEach((item) => {
        item.removeAttribute("loading");
      });
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

// I am trying to fix the crushing null pointer to the variant pic here

setActiveMedia(mediaId, prepend) {
  // Find the media panel and bail safely if not found
  const viewer = this.elements && this.elements.viewer;
  const activeMedia = viewer && viewer.querySelector(`[data-media-id="${mediaId}"]`);
  if (!activeMedia) {
    console.warn('media-gallery: no media for id', mediaId);
    return;
  }

  // Activate the requested media
  viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
  activeMedia.classList.add('is-active');

  // Optional reordering
  if (prepend) {
    if (activeMedia.parentElement) activeMedia.parentElement.prepend(activeMedia);

    if (this.elements.thumbnails) {
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail && activeThumbnail.parentElement) {
        activeThumbnail.parentElement.prepend(activeThumbnail);
      }
    }
    if (viewer.slider) viewer.resetPages?.();
  }

  this.preventStickyHeader?.();

  // Scroll media or thumbnails into view without assuming DOM is present
  window.setTimeout(() => {
    if (this.elements.thumbnails) {
      if (activeMedia.parentElement && typeof activeMedia.offsetLeft === 'number') {
        activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
      }
    }
    if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
      if (activeMedia.scrollIntoView) activeMedia.scrollIntoView({ behavior: 'smooth' });
    }
  });

  this.playActiveMedia?.(activeMedia);

  // Thumbnails section - all guarded
  if (!this.elements.thumbnails) return;

  const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
  this.setActiveThumbnail(activeThumbnail);

  const pos = activeThumbnail ? activeThumbnail.dataset.mediaPosition : '';
  this.announceLiveRegion?.(activeMedia, pos);
}

setActiveThumbnail(thumbnail) {
  // Safely no-op if there is no thumbnail list or no matching thumb
  if (!this.elements.thumbnails || !thumbnail) return;

  // Clear previous aria-current
  this.elements.thumbnails.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));

  const btn = thumbnail.querySelector('button');
  if (btn) btn.setAttribute('aria-current', 'true');

  // Guard parentElement
  if (thumbnail.parentElement && thumbnail.offsetTop < thumbnail.parentElement.scrollTop) {
    thumbnail.parentElement.scrollTo({ top: thumbnail.offsetTop });
  }
}
// That's it folks, fingers crossed

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}